import * as answerMutations from './answer';
import * as authMutations from './auth';
import * as commentMutations from './comment';
import * as questionMutations from './question';
import * as topicMutations from './topic';
import * as userMutations from './user';

export default {
  answerMutations,
  authMutations,
  commentMutations,
  questionMutations,
  topicMutations,
  userMutations,
};
